import React from "react";

const Breadcrumb = ({ course, module, subsection, onGoToCourse, onGoToModule }) => {

  return (
    <nav className="text-sm uppercase tracking-wide text-gray-400 mb-3" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1">
        {/* Course */}
        {course && (
          <li className="flex items-center">
            <button
              type="button"
              className="text-[#54B0AF] hover:underline"
              onClick={onGoToCourse}
              title={course.title}
            >
              {course.title}
            </button>
            <span className="mx-2 text-gray-300">/</span>
          </li>
        )}
        {/* Module */}
        {module && (
          <li className="flex items-center">
            <button
              type="button"
              className="text-[#54B0AF] hover:underline"
              onClick={onGoToModule}
              title={module.title}
            >
              {module.title}
            </button>
            {subsection && <span className="mx-2 text-gray-300">/</span>}
          </li>
        )}
        {/* Subsection (current) */}
        {subsection && (
          <li className="flex items-center">
            <span className="normal-case text-gray-700" title={subsection.title}>{subsection.title}</span>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
